// extracted by mini-css-extract-plugin
export default {"close-icon":"modal_close-icon__Z405z","modal-wrapper":"modal_modal-wrapper__UTenh"};